import { IconButton } from '@/components/ui/Button'
import { useTheme } from '@/hooks/useTheme'

/**
 * Light/dark switch.
 *
 * Sized to match the nav items and the read-only pill beside it. At the
 * previous 28px with a 16px glyph it read as an empty box rather than a
 * control — the one thing a theme switch must never be is hard to find in the
 * theme you want to leave.
 */
export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme()
  const next = theme === 'dark' ? 'light' : 'dark'

  return (
    <IconButton
      variant="secondary"
      label={`Switch to ${next} theme`}
      onClick={toggleTheme}
      className="text-ink-secondary hover:text-ink"
    >
      {theme === 'dark' ? (
        <svg viewBox="0 0 20 20" className="h-[18px] w-[18px]" fill="none" aria-hidden="true">
          <circle cx="10" cy="10" r="3.75" stroke="currentColor" strokeWidth="1.7" />
          <path
            d="M10 2v1.8M10 16.2V18M2 10h1.8M16.2 10H18M4.4 4.4l1.3 1.3M14.3 14.3l1.3 1.3M15.6 4.4l-1.3 1.3M5.7 14.3l-1.3 1.3"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
          />
        </svg>
      ) : (
        <svg viewBox="0 0 20 20" className="h-[18px] w-[18px]" fill="none" aria-hidden="true">
          <path
            d="M16.5 11.8A6.8 6.8 0 0 1 8.2 3.5a6.8 6.8 0 1 0 8.3 8.3z"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </IconButton>
  )
}
